import React, { useRef, useState } from "react";

import ReactToPrint from "react-to-print";

import { Flex, Spinner, Text, Box } from "@chakra-ui/react";

import RelatorioService from "../../../main/services/RelatorioService";
import { FaFilePdf } from "react-icons/fa";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../helpers/Funcionalidades";
import { ComponentToPrintRelatorioCriancaGeral } from "../ComponentToPrintRelatorioCriancaGeral";
import { cleanObject } from "../../utils/cleanObject";
import { formatDateToISOWithNow } from "../../utils/formatDateToISOWithNow";
import { parseBoolean } from "../../utils/parseBoolean";

export const PrintButtonRelatorioCriancaGeral = ({
  user,
  entidade,
  dados,
  roleKeycloack,
}) => {
  const componentToPrintRef = useRef(null);
  const [dataPendencias, setDataPendencias] = useState([]);
  const [columnsPendencias, setColumnsPendencias] = useState([]);
  const [loading, setLoading] = useState(false);
  const tempObj = JSON.parse(sessionStorage.getItem("table-" + entidade));
  const storage = JSON.parse(sessionStorage.getItem(entidade + "-filter"));

  const beforeGetContent = async () => {
    setLoading(true);
    try {
      const idsProcesso = (storage?.idProcesso || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const idsTipoSentenca = (storage?.idTipoSentenca || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const idsProcedimento = (storage?.idProcedimento || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const idsDeficiencias = storage?.deficiencias
        ? (() => {
            const flat = storage?.deficiencias.flat();

            const hasTodos = flat.some((item) => item.id === "");

            if (hasTodos) return [0];

            return flat
              .map((item) => item.idTipoDeficiencia ?? item.value)
              .filter((id) => id !== null && id !== undefined && id !== "");
          })()
        : [];

      const idsDoencas = storage?.doencas
        ? (() => {
            const flat = storage?.doencas.flat();

            const hasTodos = flat.some((item) => item.id === "");

            if (hasTodos) return [0];

            return flat
              .map((item) => item.idDoenca ?? item.value)
              .filter((id) => id !== null && id !== undefined && id !== "");
          })()
        : [];

      const generos = (storage?.idGenero || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const racas = (storage?.idRaca || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const idTipoRef = storage?.idTipoReferencia
        ? (() => {
            const flat = storage?.idTipoReferencia.flat();

            const hasTodos = flat.some((item) => item.id === "");

            if (hasTodos) return [0];

            return flat
              .map((item) => item.id ?? item.value)
              .filter((id) => id !== null && id !== undefined && id !== "");
          })()
        : [];

      const nomeServicosAcolhimentos = (storage?.idsServicosAcolhimento || [])
        ?.flat()
        ?.map((item) => item.nomeFantasia)
        ?.filter(Boolean);

      const idsJustificativas = (storage?.idJustificativas || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const idsMotivo = (storage?.idsMotivosEntrada || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const idsServicos = (storage?.idsServicosAcolhimento || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const municipiosOrgaos = (storage?.idMunicipioOrgao || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter((id) => id !== "" && id != null);
      const promotoriasOrgaos = (storage?.idPromotoriaOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);
      const varasOrgaos = (storage?.idVaraOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);

      const idadeMin = [storage?.idadeInicial].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const idadeMax = [storage?.idadeFinal].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const valuesToSend = {
        universoConsulta: {
          universo:
            storage?.universoConsulta === 1
              ? "ACOLHIDO"
              : storage?.universoConsulta === 2
                ? "DESLIGADO"
                : storage?.universoConsulta === 3
                  ? "TRANSFERENCIA"
                  : "PENDENTE",
          idsServicosAcolhimento: idsServicos,
          idsMotivosEntrada: idsMotivo,
          tipoPeriodo:
            storage?.tipoPeriodo === "A"
              ? "SITUACAO_ATUAL"
              : storage?.tipoPeriodo === "D"
                ? "DATA"
                : "",

          entradasPorTransferencias:
            storage?.entradasPorTransferencias?.includes("Possui")
              ? true
              : false,
          saidaTransferencia: storage?.saidaTransferencia?.includes("Possui")
            ? true
            : false,
          maioresDezoito: storage?.maioresDezoito?.includes("Possui")
            ? true
            : false,
          dataInicio: storage?.dataInicio
            ? formatDateToISOWithNow(storage?.dataInicio)
            : "",
          dataFim: storage?.dataFim
            ? formatDateToISOWithNow(storage?.dataFim)
            : "",
          idJustificativas: idsJustificativas,
          idTipoTransferencia: storage?.idTipoTransferencia?.id
            ? storage?.idTipoTransferencia?.id
            : null,
        },

        localizacaoServicoAcolhimento: {
          estados: storage?.idEstado
            ? storage?.idEstado
                .flat()
                .map((item) => item.id)
                .filter((item) => item.id !== "")
            : [],
          municipios: storage?.idMunicipio
            ? storage?.idMunicipio
                .flat()
                .map((item) => ({
                  id: item.id,
                  idEstado: item.idEstado,
                }))
                .filter((item) => item.id !== "")
            : [],
          bairros: storage?.idBairro
            ? storage?.idBairro
                .flat()
                .map((item) => ({
                  id: item.id,
                  idMunicipio: item.idMunicipio,
                }))
                .filter((item) => item.id !== "")
            : [],
          nomeServicosAcolhimentos: nomeServicosAcolhimentos,
        },

        orgaos: cleanObject({
          municipios: municipiosOrgaos,
          promotorias: promotoriasOrgaos,
          varasInfancias: varasOrgaos,
          orgaoConstaFichaCriancaAdoslecente:
            storage?.radioCriterioAtribuicaoCompetencia === "C" ? true : "",
          orgaoConstaFichaServicoAcolhimento:
            storage?.radioCriterioAtribuicaoCompetencia === "S" ? true : "",
          mesmoOrgaoFichaCriancaAdoslecenteEFichaServicoAcolhimento:
            storage?.radioCriterioAtribuicaoCompetencia === "CS" ? true : "",
        }),

        dadosBasicos: cleanObject({
          generos: generos,
          racasCores: racas,
          faixaEtariaDe: idadeMin,
          faixaEtariaAte: idadeMax,
          comNomeSocial: storage?.pesquisarFichas?.includes("S") ? true : "",
          comNomeFicticio: storage?.pesquisarFichas?.includes("F") ? true : "",
          comDataNascimentoEstimada: storage?.pesquisarFichas?.includes("N")
            ? true
            : "",
        }),
        referenciaFamiliarComunitaria: cleanObject({
          tiposReferencia: idTipoRef,
          nomeReferencia: storage?.nomeReferencia,
          irmaosMesmoServico: storage?.detalhamentoIrmaos?.includes("A")
            ? true
            : "",
          irmaosServicosDiferentes: storage?.detalhamentoIrmaos?.includes("AD")
            ? true
            : "",
          irmaosSemHistoricoAcolhimento: storage?.detalhamentoIrmaos?.includes(
            "H",
          )
            ? true
            : "",
          irmaosDesligados: storage?.detalhamentoIrmaos?.includes("D")
            ? true
            : "",
        }),
        saude: cleanObject({
          possuiDeficiencia: parseBoolean(storage?.radioDeficiencia),
          tiposDeficiencia: idsDeficiencias,
          possuiProblemaSaude: parseBoolean(storage?.radioProblemaSaude),
          tiposDoenca: idsDoencas,
          cartaoVacinacao:
            storage?.radioCartaoVacinacao.length > 0
              ? storage?.radioCartaoVacinacao
              : [],
          usaMedicacaoContinua: parseBoolean(storage?.radioMedicacaoContinua),
        }),
        educacao: cleanObject({
          frequentaEscola: parseBoolean(storage?.radioFrequentaEscola),
          educacaoEspecial: parseBoolean(storage?.radioEducacaoEspecial),
          escolaridadeRepetida: parseBoolean(
            storage?.radioEscolaridadeRepetida,
          ),
        }),
        profissionalizacao: cleanObject({
          possuiCursoProfissionalizante: parseBoolean(
            storage?.radioPossuiCurso,
          ),
          trabalhaAtualmente: parseBoolean(storage?.radioTrabalhaAtualmente),
          fazEstagio: parseBoolean(storage?.radioFazEstagio),
          matriculadoJovemAprendiz: parseBoolean(storage?.radioJovemAprendiz),
          possuiCurriculoVitae: parseBoolean(storage?.radioCurriculoVitae),
        }),

        ...(storage?.radioRecebeVisita &&
          typeof storage?.radioRecebeVisita === "string" && {
            visita: cleanObject({
              recebeVisita: parseBoolean(storage?.radioRecebeVisita),
              faixaPeriodo:
                storage?.faixaPeriodo?.id === 1
                  ? "NO_MES"
                  : storage?.faixaPeriodo?.id === 2
                    ? "ULTIMOS_3_MESES"
                    : storage?.faixaPeriodo?.id === 3
                      ? "ULTIMOS_6_MESES"
                      : storage?.faixaPeriodo?.id === 4
                        ? "EM_QUALQUER_PERIODO"
                        : "EM_QUALQUER_PERIODO",
            }),
          }),

        situacaoJuridica: cleanObject({
          possuiProcessoJudicial: parseBoolean(
            storage?.radioPossuiProcessoJudicial,
          ),
          tiposProcesso: idsProcesso,
          possuiProcedimentoJudicial: parseBoolean(
            storage?.radioPossuiProcedimentoJudicial,
          ),
          tiposProcedimento: idsProcedimento,
          haDecisaoLiminarFamiliaSubstituta: parseBoolean(
            storage?.radioDecisaoLiminar,
          ),
          possuiSentenca: parseBoolean(storage?.radioSentenca),
          tiposSentenca: idsTipoSentenca,
          recurso:
            storage?.radioRecurso === "S"
              ? "S"
              : storage?.radioRecurso === "N"
                ? "N"
                : storage?.radioRecurso === "I"
                  ? "I"
                  : "",
          transitoEmJulgado: parseBoolean(storage?.radioTransitoJulgado),
        }),
        situacaoAdocao: {
          cumpreRequisitosAdocao: parseBoolean(storage?.radioCumpreRequisito),
        },

        ...(storage?.radioIncluidoPrograma &&
          typeof storage?.radioIncluidoPrograma === "string" && {
            programaApadrinhamento: cleanObject({
              incluidoProgramaApadrinhamento:
                storage?.radioIncluidoPrograma === "S"
                  ? "SIM"
                  : storage?.radioIncluidoPrograma === "N"
                    ? "NAO"
                    : storage?.radioIncluidoPrograma === "SI"
                      ? "SEM_INFORMACAO"
                      : "",
              sendoApadrinhado:
                storage?.radioSendoApadrinhado === "S"
                  ? "SIM"
                  : storage?.radioSendoApadrinhado === "N"
                    ? "NAO"
                    : storage?.radioSendoApadrinhado === "SI"
                      ? "SEM_INFORMACAO"
                      : "",
            }),
          }),
        pageSize: 9999999,
        page: 0,
        sortField: tempObj ? tempObj[0]?.id : "nomeCrianca",
        sortType: tempObj ? (tempObj[0]?.desc ? "DESC" : "ASC") : "ASC",
      };

      const res = await RelatorioService.getRelatorioCriancaGeral(valuesToSend);

      if (res?.data) {
        setColumnsPendencias([
          {
            Header: "Nome/Nome Social",
            accessor: "nomeCrianca",
            Cell: (props) => {
              let name = props?.row?.original?.nomeCrianca;
              const descricaoTipoSituacao =
                props?.row?.original?.descricaoTipoSituacao;
              const temRiscoVida =
                props?.row?.original?.riscoVida === "S" ? true : false;
              const idMovimento = props?.row?.original?.idMovimento;

              if (props?.row?.original?.nomeSocial) {
                name = name + " / " + props.row.original.nomeSocial;
              }

              return (roleKeycloack &&
                roleKeycloack.includes(criancaFunc.visualizar)) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarPartePPCAAM,
                ) ? (
                !temRiscoVida ? (
                  <Box wordBreak={"break-all"}>
                    <Flex alignItems="center" gap={2}>
                      {descricaoTipoSituacao === "Acolhido" &&
                      idMovimento === 2 ? (
                        <Box
                          w="4"
                          h="4"
                          bg="#169499"
                          borderRadius="full"
                          border="1px"
                          color="#169499"
                        />
                      ) : descricaoTipoSituacao === "Acolhido" ||
                        descricaoTipoSituacao === "Desligado" ? (
                        <Box w="3" h="3" borderRadius="full" />
                      ) : (
                        <Box
                          w="4"
                          h="4"
                          bg="red"
                          borderRadius="full"
                          border="1px"
                          color="red"
                        />
                      )}
                      <Text
                        display="flex"
                        h={"40px"}
                        alignItems={"center"}
                        minWidth="250px"
                      >
                        {name}
                      </Text>
                    </Flex>
                  </Box>
                ) : (
                  <Box wordBreak={"break-all"} title={name}>
                    <Flex alignItems="center" gap={2}>
                      {descricaoTipoSituacao === "Acolhido" &&
                      idMovimento === 2 ? (
                        <Box
                          w="4"
                          h="4"
                          bg="#169499"
                          borderRadius="full"
                          border="1px"
                          color="#169499"
                        />
                      ) : descricaoTipoSituacao === "Acolhido" ||
                        descricaoTipoSituacao === "Desligado" ? (
                        <Box w="3" h="3" borderRadius="full" />
                      ) : (
                        <Box
                          w="4"
                          h="4"
                          bg="red"
                          borderRadius="full"
                          border="1px"
                          color="red"
                        />
                      )}
                      <Text
                        display="flex"
                        h={"40px"}
                        alignItems={"center"}
                        minWidth="250px"
                      >
                        {name}
                      </Text>
                    </Flex>
                  </Box>
                )
              ) : !temRiscoVida ? (
                <Flex alignItems="center" gap={2}>
                  {descricaoTipoSituacao === "Acolhido" ||
                  descricaoTipoSituacao === "Desligado" ? (
                    <Box w="3" h="3" borderRadius="full" />
                  ) : (
                    <Box
                      w="3"
                      h="3"
                      bg="red"
                      borderRadius="full"
                      border="1px"
                      color="red"
                    />
                  )}
                  <Text
                    display="flex"
                    h={"40px"}
                    alignItems={"center"}
                    minWidth="250px"
                  >
                    {name}
                  </Text>
                </Flex>
              ) : (
                <Flex alignItems="center" gap={2}>
                  {descricaoTipoSituacao === "Acolhido" ||
                  descricaoTipoSituacao === "Desligado" ? (
                    <Box w="3" h="3" borderRadius="full" />
                  ) : (
                    <Box
                      w="3"
                      h="3"
                      bg="red"
                      borderRadius="full"
                      border="1px"
                      color="red"
                    />
                  )}
                  <Text
                    display="flex"
                    h={"40px"}
                    alignItems={"center"}
                    minWidth="250px"
                  >
                    {name}
                  </Text>
                </Flex>
              );
            },
          },
          {
            Header: "Gênero",
            accessor: "genero",
            Cell: (props) => {
              return <span>{props.value}</span>;
            },
          },
          {
            Header: "Data de Nascimento",
            accessor: "dataNascimento",

            Cell: (props) => {
              return <span>{props.value}</span>;
            },
          },

          {
            Header: "Idade",
            accessor: "idade",
            Cell: (props) => {
              return <Text>{props.value ?? ""}</Text>;
            },
          },
          {
            Header: "Filiação",
            accessor: "filiacoes",
            sortType: (rowA, rowB, id, desc) => {
              const filiacoesA = rowA?.original?.filiacoes?.length
                ? rowA.original.filiacoes
                    .map((filiacao) => filiacao?.filiacao?.nome || "")
                    .reduce((prev, filiacao) => prev + filiacao, "")
                : "";
              const filiacoesB = rowB?.original?.filiacoes?.length
                ? rowB.original.filiacoes
                    .map((filiacao) => filiacao?.filiacao?.nome || "")
                    .reduce((prev, filiacao) => prev + filiacao, "")
                : "";
              return filiacoesA.localeCompare(filiacoesB, "pt-BR");
            },
            Cell: (props) => {
              return props?.value
                .sort((a, b) =>
                  a.descricaoTipoRelacionamento.localeCompare(
                    b.descricaoTipoRelacionamento,
                  ),
                )
                .map((filiacao, index) => {
                  return (
                    <React.Fragment key={index}>
                      <span style={{ whiteSpace: "nowrap" }}>
                        {filiacao?.nome}{" "}
                        <Text as="span" textTransform="capitalize">
                          ({filiacao?.descricaoTipoRelacionamento.toLowerCase()}
                          )
                        </Text>
                      </span>
                      {props.value.length - 1 !== index && <br />}
                    </React.Fragment>
                  );
                });
            },
          },
          {
            Header: "Serviço de Acolhimento Atual",
            accessor: "servicoAcolhimentoAtual",
            sortType: (rowA, rowB, id, desc) => {
              const nomeServicoA = rowA?.original?.servicoAcolhimentoAtual
                ? rowA.original.servicoAcolhimentoAtual.nomeFantasia
                : "";
              const nomeServicoB = rowB?.original?.servicoAcolhimentoAtual
                ? rowB.original.servicoAcolhimentoAtual.nomeFantasia
                : "";
              return nomeServicoA?.localeCompare(nomeServicoB, "pt-BR");
            },
            Cell: (props) => {
              const permissaoServico =
                roleKeycloack.includes(criancaFunc.visualizarTudo) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarPartePPCAAM,
                ) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarParteMP,
                ) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarParteTJ,
                ) ||
                ((roleKeycloack.includes(
                  criancaFunc.visualizarTudoAcolhimento,
                ) ||
                  roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
                  user?.orgaoExterno?.includes(
                    props?.row?.original?.servicoAcolhimentoAtual
                      ?.idPessoaJuridica,
                  ));
              const temRiscoVida =
                props?.row?.original?.riscoVida === "S" ? true : false;

              if (temRiscoVida && !permissaoServico) {
                return <span></span>;
              } else {
                const idServico =
                  props?.row?.original?.servicoAcolhimentoAtual?.id;
                if (!idServico) {
                  return <span></span>;
                } else {
                  return (
                    <>
                      {roleKeycloack &&
                      roleKeycloack.includes(
                        servicoAcolhimentoFunc.visualizar,
                      ) ? (
                        <Box
                          wordBreak={"break-word"}
                          title={
                            props?.value
                              ? props?.value?.nomeFantasia +
                                `${
                                  props?.value?.suspenso === "S"
                                    ? " (Suspenso)"
                                    : ""
                                }`
                              : ""
                          }
                        >
                          <Text>
                            {" "}
                            {props?.value
                              ? props?.value?.nomeFantasia +
                                `${
                                  props?.value?.suspenso === "S"
                                    ? " (Suspenso)"
                                    : ""
                                }`
                              : ""}
                          </Text>
                        </Box>
                      ) : (
                        <Text>
                          {props?.value
                            ? props?.value?.nomeFantasia +
                              `${props?.value?.suspenso === "S" ? " (Suspenso)" : ""}`
                            : ""}
                        </Text>
                      )}
                    </>
                  );
                }
              }
            },
          },
        ]);
      }

      setDataPendencias(res?.data?.content);

      setLoading(false);
    } catch (erro) {
      console.log("Erro ao acessar os dados de impressao");
      console.log(erro);
      setLoading(false);
    }
  };

  const customPageStyle = `
    @page {
      margin: 0mm;
      size: auto;  
      margin-top: 0mm; 
      margin-bottom: 12mm; 
    } 
    @media print { 
      body { 
        -webkit-print-color-adjust: exact; 
      } 
    }
  `;

  return (
    <>
      <ReactToPrint
        onBeforeGetContent={beforeGetContent}
        onAfterPrint={() => setLoading(false)}
        pageStyle={customPageStyle}
        documentTitle={`MCA - Relatório de Crianças e Adolescentes`}
        trigger={() => {
          return loading ? (
            <Spinner size="sm" />
          ) : (
            <Flex
              alignItems="center"
              gap={2}
              cursor="pointer"
              onClick={() => alert("imprimir PDF")}
            >
              <Flex bg="red" rounded="full" p={1}>
                <FaFilePdf color="white" />
              </Flex>

              <Text as="b" color="red" fontSize={"md"}>
                Exportar em PDF
              </Text>
            </Flex>
          );
        }}
        content={() => componentToPrintRef.current}
      />
      <div style={{ display: "none" }}>
        <ComponentToPrintRelatorioCriancaGeral
          ref={componentToPrintRef}
          dataPendencias={dataPendencias ? dataPendencias : null}
          columnsPendencias={columnsPendencias}
          roleKeycloack={roleKeycloack}
          dados={dados}
          user={user}
          storage={storage}
        />
      </div>
    </>
  );
};
